import { Alert, Snackbar } from "@mui/material";
import classes from "./ToastStyles.module.scss";
import React, { useEffect, useState } from "react";
import Slide, { SlideProps } from "@mui/material/Slide";
import successicon from "../../Components/assets/Images/snacksuccess.svg";
type TransitionProps = Omit<SlideProps, "direction">;

function TransitionUp(props: TransitionProps) {
  return <Slide {...props} direction="left" />;
}

interface props {
  message: string;
}

export default function SucessSnackBar({ message }: props) {
  const [transition, setTransition] = React.useState<
    React.ComponentType<TransitionProps> | undefined
  >(undefined);
  const [open, setOpen] = useState(false);
  //console.log("message", message)

  useEffect(() => {
    if (message) {
      setOpen(true);
      setTransition(() => TransitionUp);
      setTimeout(() => {
        setOpen(false);
      }, 3000);
    }
  }, [message]);

  // console.log(message)
  return (
    <div>
      <Snackbar
        open={open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        TransitionComponent={transition}
        sx={{ marginTop: "60px" }}
      >
        <div
          className={`${classes.wrapper} animate__animated animate__fadeInRight`}
        >
          <img src={successicon} alt="" />
          <div className={classes.content}>
            <div className={classes.text1}>Success</div>
            <div className={classes.text2}>{message}</div>
          </div>
        </div>
        {/* <div style={{ background: "#54BF00", borderRadius: "10px " }}>
          <div style={{ marginLeft: "30px" }}>
            <Alert
              icon={false}
              severity="success"
              sx={{
                width: { xs: "90%", sm: "max-content" },
                height: "50px",
                fontSize: "16px",
                borderRadius: "0",
                display: "flex",
                textWrap: "wrap",
                alignItems: "center",
                background: "#EAFFE9",
                fontFamily: "inherit",
                color:"#000"
              }}
            >
              {message}
            </Alert>
          </div>
        </div> */}
      </Snackbar>
    </div>
  );
}
